import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { StepForm, ConfiguratorStepTitleAndDescription } from '@grandvisionhq/configurator';
import { ConfiguratorRadioTile } from '../../../../../../Configurator/components/ConfiguratorRadioTile/ConfiguratorRadioTile.js';
import { RxStepWrapper } from '../RxStepWrapper/RxStepWrapper.js';
import DesktopStepLayout from '../DesktopStepLayout/DesktopStepLayout.js';
import { FrameImage } from '../FrameImage/FrameImage.js';

const VariantSelectionStep = ({ className , itemsList , selectedItemSku , onChange , onSubmit ,  })=>{
    const showFrameImage = MediaQuery.useIsBelow(MediaQuery.BreakpointName.DESKTOP);
    const isDesktop = MediaQuery.useIsDesktop();
    return /*#__PURE__*/ React.createElement(RxStepWrapper, {
        className: classnames('variant-selection-step', className)
    }, /*#__PURE__*/ React.createElement(DesktopStepLayout, null, /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit,
        className: "variant-selection-step__wrapper"
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: isDesktop ? 'left' : 'center'
    }), showFrameImage && /*#__PURE__*/ React.createElement(FrameImage, null), /*#__PURE__*/ React.createElement("div", {
        className: classnames('variant-selection-step__products', className)
    }, /*#__PURE__*/ React.createElement("fieldset", {
        className: "variant-selection-step__list"
    }, itemsList.map((item)=>{
        var ref;
         return React.createElement(ConfiguratorRadioTile, {
            className: "variant-selection-step__list-item",
            isSelected: selectedItemSku === item.sku,
            onChange: onChange,
            value: item.sku,
            key: item.sku,
            title: item.title,
            headerRowImage: (ref = item.image) === null || ref === void 0 ? void 0 : ref.url,
            description: item.description,
            price: item.price,
            discountText: item.discountText
        });
    }))))));
};

export { VariantSelectionStep };
//# sourceMappingURL=VariantSelectionStep.js.map
